// Configuración de palabras clave para SEO
export const seoKeywords = {
  primary: [
    'renta de impresoras',
    'renta impresoras los cabos', 
    'renta impresoras cabo san lucas',
    'impresoras multifuncionales los cabos',
    'equipos canon hp los cabos'
  ],
  secondary: [
    'renta equipos oficina los cabos',
    'impresoras en renta bcs',
    'servicio tecnico impresoras',
    'multifuncionales canon hp',
    'renta impresoras sin inversion'
  ],
  local: [
    'los cabos',
    'cabo san lucas', 
    'san jose del cabo',
    'baja california sur',
    'bcs'
  ],
  brands: [
    'canon',
    'hp',
    'multifuncional canon',
    'multifuncional hp'
  ]
};

// Contenido optimizado para SEO
export const seoContent = {
  title: 'Renta de Impresoras Los Cabos | Servi Copy del Pacífico',
  description: 'Especialistas en renta de impresoras multifuncionales Canon y HP en Los Cabos. +15 años de experiencia, sin inversión inicial, servicio técnico incluido.',
  
  // Preguntas frecuentes optimizadas para SEO
  faqs: [
    {
      question: '¿Qué incluye la renta de impresoras?',
      answer: 'Incluye instalación, capacitación, servicio técnico, tóner y refacciones. Solo pagas el papel.'
    },
    {
      question: '¿Ofrecen renta de impresoras sin inversión inicial?',
      answer: 'Sí, nuestros planes de renta no requieren inversión inicial y son flexibles según tu presupuesto.'
    },
    {
      question: '¿Qué marcas de impresoras rentan?',
      answer: 'Rentamos equipos multifuncionales de las mejores marcas: Canon y HP, todos de última generación.'
    },
    {
      question: '¿Dan servicio en Los Cabos?',
      answer: 'Sí, brindamos servicio en Los Cabos, Cabo San Lucas, San José del Cabo y La Paz, BCS.'
    }
  ]
};

export default { seoKeywords, seoContent };